var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"id":"app"}},[_c('b-card',[_c('SearchBar',{on:{"SearchKeyRT":function($event){_vm.searchObj = $event}}}),_c('hr'),_c('FileList',{attrs:{"itemsArg":_vm.results}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }